import basic from '../basic/en';
export default {
    ...basic,
    ...{
        textimghomeindex: {
            titlebefore: 'Enhance',
            titleafter: 'Your Visuals with AI for Images and Videos',
            subtitle: 'Elevate your video resolution in a single click, transforming your visuals into breathtaking, high-quality masterpieces.',
            buttontext: 'Free trial now',
        },
        showcasehomeindex: {
            title: 'AI Generated Images',
            buttontext: 'Free trial now',
            hovertitle: 'Try this prompt',
        },
        introducehomeindex: {
            item1title: 'Unleash the Power of Enhancement',
            item1subtitle: 'Transform your visuals with our advanced AI enhancement tools. Instantly improve the quality of your images and videos, bringing out vibrant colors and stunning details. Whether you\'re a content creator, marketer, or enthusiast, experience professional-grade enhancements that captivate your audience and elevate your storytelling.',
            item1buttontext: 'Free trial now',
            item2title: 'Generate Real Soulmate with Inspiration',
            item2subtitle: 'As an easy-to-use AI Image Generator, we aim to fulfill your dream with great effort. Describe your dream image with simply words and we will generate your art in seconds!',
            item2buttontext: 'Free trial now',
        },
        FAQTitle: 'Frequently Asked Questions',
    },
};
